// extracted by mini-css-extract-plugin
export default {"App":"Payment_App__q7JuW","form":"Payment_form__-+0Q+","details":"Payment_details__+mUH5","submit_btn":"Payment_submit_btn__AEuiK"};